"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-input", {
    staticClass: "filter-item",
    style: {
      width: Math.max(160, (_vm.listQuery.name ? _vm.listQuery.name.length * 9 : 0) + 40) + "px"
    },
    attrs: {
      placeholder: "Company Name"
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.name,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "name", $$v);
      },
      expression: "listQuery.name"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "enabled", $$v);
      },
      expression: "listQuery.enabled"
    }
  }, [_c("el-option", {
    attrs: {
      value: true,
      label: "Enabled"
    }
  }), _c("el-option", {
    attrs: {
      value: false,
      label: "Disabled"
    }
  })], 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "small",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" Search ")]), _c("router-link", {
    attrs: {
      to: "/companies/add"
    }
  }, [_c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      size: "small",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" Add Company ")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "ID",
      prop: "id",
      width: "70"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "240px",
      align: "center",
      label: "Logo",
      prop: "logo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.logo ? _c("el-image", {
          staticStyle: {
            width: "100px",
            height: "100px"
          },
          attrs: {
            src: scope.row.logo,
            fit: "fill"
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "GST",
      prop: "gstNumber"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "PAN",
      prop: "panNumber"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Created",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY hh:mm a")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Actions",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/companies/edit/" + scope.row.id
          }
        }, [_c("el-button", {
          attrs: {
            type: "warning",
            size: "mini",
            icon: "el-icon-edit"
          }
        })], 1)];
      }
    }])
  })], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    staticClass: "pagination-wrapper"
  }, [_c("el-pagination", {
    staticClass: "pagination-mobile",
    attrs: {
      layout: "prev, pager, next",
      total: _vm.total,
      "page-size": _vm.listQuery.limit,
      "current-page": _vm.listQuery.page,
      small: ""
    },
    on: {
      "update:currentPage": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:current-page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "current-change": _vm.getList
    }
  }), _c("el-pagination", {
    staticClass: "pagination-desktop",
    attrs: {
      layout: "total, sizes, prev, pager, next, jumper",
      total: _vm.total,
      "page-size": _vm.listQuery.limit,
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.listQuery.page
    },
    on: {
      "update:currentPage": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:current-page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "size-change": val => {
        _vm.listQuery.limit = val;
        _vm.getList();
      },
      "current-change": _vm.getList
    }
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;